import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Link } from "react-router-dom";
import MuiPhoneNumber from "material-ui-phone-number";

import logoImg from "./images/logo.png";
import "./style.css";

export class SignUpForm extends Component {
  render() {
    const {
      email,
      firstname,
      lastname,
      password,
      phone,
      passwordLength,
      containsNumbers,
      isUppercase,
      containsSymbols,
      isLowercase,
      errorMessage,
      handleSubmit,
      handleChange,
      handleChange1,
      handleChangePhone,
    } = this.props;

    // Check phone validation: requires at least 10 numeric digits
    const phoneDigits = (phone || "").replace(/\D/g, "");
    const isPhoneValid = phoneDigits.length >= 10;

    const isPasswordValid =
      passwordLength &&
      containsNumbers &&
      isUppercase &&
      containsSymbols &&
      isLowercase;

    const isFormValid =
      email && firstname && lastname && isPasswordValid && isPhoneValid;

    return (
      <div className="login">
        <CssBaseline />
        <Container maxWidth="xs">
          <Card className="login-card" style={{ marginTop: "50px" }}>
            <div className="logo">
              <img alt="logo" className="logo-custom" src={logoImg} />
            </div>

            <form onSubmit={handleSubmit} className="main-form">
              {errorMessage && <p className="a-errorMessage">{errorMessage}</p>}

              <h4 className="label-head">Sign up with a new account</h4>

              {/* Email */}
              <div className="a-form-ctrl">
                <p>Email</p>
                <input
                  className="a-input"
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={this.props.email || ""}
                  required
                  onChange={this.props.handleChange1}
                />
              </div>

              {/* Mobile Number */}
              <div className="a-form-ctrl">
                <p>Mobile Number</p>
                <MuiPhoneNumber
                  required
                  name="phone"
                  variant="filled"
                  defaultCountry="us"
                  onlyCountries={["us"]}
                  autoComplete="off"
                  value={this.props.phone || ""}
                  length={17}
                  onChange={this.props.handleChangePhone}
                  fieldType={'phone'}
                  errMsg={'Enter valid mobile no.'} 
                  helperMsg={'Mobile no. required'}
                  className="myPhone"
                  error={
                    this.props.phone.length !== 17 &&
                    this.props.phone.length !== 0
                  }
                  InputLabelProps={{
                    style: {
                      color:
                        this.props.phone.length !== 17 &&
                        this.props.phone.length !== 0
                          ? "#FA1515"
                          : "",
                    },
                  }}
                  // style={customStyle.textFieldWrpAgent}
                  helperText={
                    this.props.phone.length !== 17
                      ? "Mobile no. required"
                      : ""
                  }
                />
              </div>

              {/* First Name */}
              <div className="a-form-ctrl">
                <p>First Name</p>
                <input
                  className="a-input"
                  type="text"
                  placeholder="First Name"
                  name="firstname"
                  value={this.props.firstname || ""}
                  required
                  onChange={this.props.handleChange1}
                />
              </div>

              {/* Last Name */}
              <div className="a-form-ctrl">
                <p>Last Name</p>
                <input
                  className="a-input"
                  type="text"
                  placeholder="Last Name"
                  name="lastname"
                  value={this.props.lastname || ""}
                  required
                  onChange={this.props.handleChange1}
                />
              </div>

              {/* Password */}
              <div className="a-form-ctrl">
                <p>Password</p>
                <input
                  className="a-input"
                  type="password"
                  placeholder="Enter Password"
                  name="password"
                  value={password || ""}
                  required
                  onChange={handleChange}
                />
              </div>

              {/* Password Rules Checklist */}
              <div className="pwd-validations">
                <div className={isLowercase ? "valid" : "invalid"}>
                  <span aria-hidden="true">{isLowercase ? "✓" : "✖"} </span>
                  <span className="pwd-validation-txt">
                    Password must contain a lower case letter
                  </span>
                </div>
                <div className={isUppercase ? "valid" : "invalid"}>
                  <span aria-hidden="true">{isUppercase ? "✓" : "✖"} </span>
                  <span className="pwd-validation-txt">
                    Password must contain an upper case letter
                  </span>
                </div>
                <div className={containsSymbols ? "valid" : "invalid"}>
                  <span aria-hidden="true">{containsSymbols ? "✓" : "✖"} </span>
                  <span className="pwd-validation-txt">
                    Password must contain a special character
                  </span>
                </div>
                <div className={containsNumbers ? "valid" : "invalid"}>
                  <span aria-hidden="true">{containsNumbers ? "✓" : "✖"} </span>
                  <span className="pwd-validation-txt">
                    Password must contain a number
                  </span>
                </div>
                <div className={passwordLength ? "valid" : "invalid"}>
                  <span aria-hidden="true">{passwordLength ? "✓" : "✖"} </span>
                  <span className="pwd-validation-txt">
                    Password must contain at least 8 characters
                  </span>
                </div>
              </div>

              {/* CTA Submit Button */}
              <div>
                <button type="submit" className="a-btn" disabled={!isFormValid}>
                  Sign Up
                </button>

                <p style={{ textAlign: "center", marginTop: "12px" }}>
                  <span>Already have an account?</span>&nbsp;
                  <span className="forgot-pawd">
                    <Link to={"/login" + window.location.hash}>Sign In</Link>
                  </span>
                </p>
              </div>
            </form>
          </Card>
        </Container>
      </div>
    );
  }
}

export default SignUpForm;
